import { getConfig } from "../../utils/getConfig";
import { useLocalePublicPath } from "../../utils/usePublicPath";

export const PageHead: React.FC = () => {
	const faviconVersion = "3";
	const isBreadTenant = getConfig("tenant") === "bread";
	const publicPath = useLocalePublicPath();

	return (
		<>
			<meta
				name="description"
				content={
					isBreadTenant
						? "You can sign in to make a payment on your Bread Pay loan or your Bread Loan. Easily manage your loan from our Member Portal."
						: "Member Portal"
				}
			/>
			<link
				rel="icon"
				href={`${publicPath}/favicons/favicon.ico?v=${faviconVersion}`}
				type="image/x-icon"
			/>
			<link
				rel="icon"
				href={`${publicPath}/favicons/icon.svg?v=${faviconVersion}`}
				type="image/svg+xml"
			/>
			<link
				rel="apple-touch-icon"
				href={`${publicPath}/favicons/apple-touch-icon.png?v=${faviconVersion}`}
				type="image/png"
			/>
			<link
				rel="manifest"
				href={`${publicPath}/favicons/site.webmanifest?v=${faviconVersion}`}
				type="application/manifest+json"
			/>
			<meta name="mobile-web-app-capable" content="yes" />
			<meta name="theme-color" content="#fff" />
			<meta
				name="msapplication-TileImage"
				content={`${publicPath}/favicons/android-chrome-192x192.png`}
			/>
		</>
	);
};
